import isClient from "../../common/isClient";
import getFormattedLocale from '../getFormattedLocale';
import getLocaleFromAEMLocaleInfo from '../getLocaleFromAEMLocaleInfo';
import getLocaleFromDOM from '../getLocaleFromDOM';
import getLocaleFromUrl from '../getLocaleFromUrl';
import parseLocale from '../parseLocale';
import parseLocaleFromPath from '../parseLocaleFromPath';
/**
 * Gets user's current locale. If the format is specified, corresponding formatted value will be retrieved.
 * The source used for parsing of locale depends on path and options passed to the function.
 * If the path is not passed the default value will be set to `window.location.pathname`
 * if the window object is defined.
 * Options config object has higher priority than path param. Getting locale depends of parameters:
 * - useAEMLocaleInfo (if true, locale will be parsed from the window.localeInfo.locale)
 * - useLocaleFromDOM (iftrue, locale will be parsed from the HTML lang attribute)
 * - useLocaleFromEnv (if it is set to true, locale will be parsed from env variable with name NEXT_PUBLIC_AEM_LOCALE).
 * @example
 * // returns sv_se if the function is executed in the browser (isClient() returns true)
 * // and window location contains sv_se (e.g. /sv_se/ladies/new-arrivals)
 * getLocale()
 * @example
 * // returns EN_GB if the function is executed on the server-side (isClient() returns false)
 * getLocale('upperCase')
 * @param {string|null} format - Format type.
 * @param {string} altLocale - Alternative Locale.
 * @param {string|null} [path] - Path to be parsed.
 * @param {object} options - Additional options.
 * @returns {string} - Formatted locale if the format is specified.
 */
const getLocale = (format = 'lowerCase', altLocale = 'en_gb', path, options) => {
    var _a;
    const locale = ((options === null || options === void 0 ? void 0 : options.useAEMLocaleInfo) && getLocaleFromAEMLocaleInfo()) ||
        ((options === null || options === void 0 ? void 0 : options.useLocaleFromDOM) && getLocaleFromDOM()) ||
        ((options === null || options === void 0 ? void 0 : options.useLocaleFromUrl) && getLocaleFromUrl());
    const locationPath = isClient() ? (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.pathname : null;
    const pathToParse = path || locationPath;
    let localeInfo = locale ? parseLocale(locale) : parseLocaleFromPath(pathToParse);
    if (!localeInfo)
        localeInfo = parseLocale(altLocale);
    return getFormattedLocale(localeInfo, format);
};
export default getLocale;
//# sourceMappingURL=getLocale.js.map